<div class="loading" [hidden]="!loading">
  <div class="loader">Loading...</div>
</div>
<div *ngIf="quickBooksIntegrationStep === 3" class="panel-body">
  <p>
    You can use Client Hub to automatically create Client Tasks for
    uncategorized expenses. You will be able to connect to QuickBooks and select
    a client QuickBooks company for this function.
  </p>

  <div class="action-wrapper">
    <div class="row d-flex align-items-center">
      <div class="col-sm-5">
        <input
          [(ngModel)]="selected"
          [typeahead]="workspaces | activeClientsOnly"
          typeaheadOptionField="name"
          (typeaheadOnSelect)="selectWorkspaceForIntegration($event)"
          [typeaheadOptionsLimit]="9999"
          [typeaheadMinLength]="0"
          placeholder="Map to an existing workspace"
          class="form-control chevron"
        />
      </div>
    </div>
  </div>
</div>
<div *ngIf="quickBooksIntegrationStep === 4" class="panel-body">
  <h3>
    Authenticate in QuickBooks to select a company and choose the uncategorized
    account for it
  </h3>
  <p>
    You can use Client Hub to automatically create Client Tasks for
    uncategorized expenses. Below you can manage client QuickBooks companies
    integration.
  </p>
  <table class="table table-borderless table-striped">
    <thead>
      <tr>
        <th>Client Hub Workspace</th>
        <th>QuickBooks Company</th>
        <th>QuickBooks Uncategorized Account</th>
        <th>Classes</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let entry of quickbooksData; let i = index">
        <td>{{ entry.workspace_name }}</td>
        <td>
          <img
            *ngIf="!entry.is_integrated"
            (click)="launchAuthenticationForm(entry.workspace_id)"
            style="cursor: pointer"
            class="connect-to-quickbooks-button"
            src="assets/img/C2QB_green_btn_med_default.svg"
            onmouseover="this.src='assets/img/C2QB_green_btn_med_hover.svg'"
            onmouseout="this.src='assets/img/C2QB_green_btn_med_default.svg'"
            class="connect-to-quickbooks-button"
            alt="Connect to QuickBooks"
          />
          {{ entry.company_name }}
        </td>
        <td class="fix-dropdown-flow">
          <button (click)="openQboAccountsModal(entry)">Manage Accounts</button>
        </td>
        <td>
          <span *ngIf="entry.is_integrated && entry.class_tracking != null">{{
            entry.class_tracking ? "Yes" : "No"
          }}</span>
        </td>
        <td class="text-left">
          <a
            class=""
            *ngIf="entry.is_integrated"
            (click)="refreshPreferences(entry.uuid, i)"
          >
            <i class="feather trash visible-xs"></i
            ><span class="hidden-xs">Refresh</span>
          </a>
          &nbsp;
          <a
            class="color-red-hover"
            *ngIf="entry.is_integrated"
            (click)="
              disconnectWorkspaceConfirmationModal(
                entry.uuid,
                entry.company_name
              )
            "
          >
            <i class="feather trash visible-xs"></i
            ><span class="hidden-xs">Remove</span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="add-another-qb-company" (click)="quickBooksIntegrationStep = 3">
    <i class="feather plus"></i>
    <span>Add Another QuickBooks company</span>
  </div>
</div>
